import { Check, Star, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { PRICING } from "@/data/content";
import { openLeadModal } from "@/components/LeadModal";

const Pricing = () => (
  <section id="pricing" data-testid="pricing-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="glow-blob w-[32rem] h-[32rem] bg-indigo-600/10 top-1/3 -right-52" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        align="center"
        caption="Pricing Plans"
        title={<>Pick your stage. <span className="text-gradient">We bring the crowd.</span></>}
        description="Transparent INR pricing — every plan includes on-ground activation plus social-first content delivery."
        testId="pricing-heading"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
        {PRICING.map((plan, i) => (
          <Reveal key={plan.name} delay={i * 0.12} className="h-full">
            <div
              data-testid={`pricing-card-${plan.name.toLowerCase()}`}
              className={`relative rounded-2xl p-7 h-full flex flex-col ${
                plan.popular ? "glow-border-strong" : "glass card-glow-hover"
              }`}
            >
              {plan.popular && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 btn-gradient text-white text-xs font-bold uppercase tracking-[0.15em] px-4 py-1.5 rounded-full inline-flex items-center gap-1.5 whitespace-nowrap">
                  <Star className="w-3 h-3 fill-current" /> Most Popular
                </span>
              )}
              <h3 className="font-display text-lg font-bold text-white uppercase tracking-wide">{plan.name}</h3>
              <div className="mt-4">
                {plan.pricePrefix && <span className="block text-xs text-zinc-500 uppercase tracking-[0.2em] mb-1">{plan.pricePrefix}</span>}
                <span className={`block font-sans font-bold tracking-normal whitespace-nowrap text-4xl lg:text-3xl xl:text-4xl ${plan.popular ? "text-gradient" : "text-white"}`}>
                  {plan.price}
                </span>
              </div>
              <p className="mt-4 text-xs text-zinc-400 leading-relaxed">{plan.tagline}</p>
              <ul className="mt-6 space-y-2.5 flex-1">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-[13px] text-zinc-300 leading-snug">
                    <Check className="w-4 h-4 mt-0.5 text-indigo-400 shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`pricing-cta-${plan.name.toLowerCase()}`}
                onClick={() => openLeadModal(`${plan.name} Plan (${plan.price})`)}
                className={`mt-8 w-full py-3 rounded-full text-sm font-semibold inline-flex items-center justify-center gap-2 ${
                  plan.popular
                    ? "btn-gradient text-white"
                    : "border border-white/15 text-white hover:border-indigo-400/60 hover:bg-white/5 transition-colors duration-300"
                }`}
              >
                Get {plan.name} <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Pricing;
